import httpClient from '@/http-client'

export const get = (options = {}) => {
  return httpClient
    .get('/api/driver-profiles', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, options = {}) => {
  return httpClient
    .get(`/api/driver-profiles/${id}`, options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/driver-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/driver-profiles/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const uploadImage = data => {
  return httpClient
    .post('/api/driver-profiles/upload-images', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
  return httpClient
    .get('/api/driver-profiles/form-view-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/driver-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const viewTelegramChatId = (options = {}) => {
  return httpClient
    .get("/api/driver-profiles/telegram-chat-id", options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data));
}
export const updateTelegramChatId = data => {
  return httpClient
    .put("/api/driver-profiles/update-telegram-chat-id", data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data));
}


export default {
  get,
  find,
  store,
  update,
  destroy,
  uploadImage,
  formModel,
  viewTelegramChatId,
  updateTelegramChatId
}